import Popover from 'antd/es/popover';
import styled from 'styled-components';

export const StyledPromotionGroup = styled.div``;

export const DesktopPromotionsContainer = styled.div`
  max-width: fit-content;
  display: flex;
  align-items: center;
  width: 100%;
`;

export const PromotionHiddenButton = styled.button`
  color: ${({ theme }) => theme.palette.clearBlue};
  cursor: pointer;
  margin-left: 10px;
  padding: 8px;
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  box-shadow: none;
`;

export const ResponsivePromotionContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  & {
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
  }
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

export const StyledCompanyPromotionItem = styled.div`
  border-radius: 2px;
  border: solid 1px ${({ theme }) => theme.palette.gray87};
  background-color: ${({ theme }) => theme.palette.white};
  padding: 8px;
  display: flex;
  align-items: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    display: flex;
    min-width: fit-content;
    height: 100%;
    align-items: center;
    background-color: ${({ theme }) => theme.palette.lynxWhite};
    padding: 8px;
    margin-right: 15px;
    border-radius: 4px;
    border: solid 1px ${({ theme }) => theme.palette.gray87};
    background-color: ${({ theme }) => theme.palette.white};
    padding: 8px;
  }
`;

export const PromotionLabel = styled.span`
  margin-left: 12px;
`;

export const StyledPopover = styled(Popover)`
  &&& {
    .setur-popover-arrow span {
      transform: scale(1.3);
    }
  }
`;
